import { useEffect } from "react";
import { updateSEOMeta, type SEOMeta } from "@/utils/seo";

export function useSEO(meta: SEOMeta) {
  useEffect(() => {
    updateSEOMeta(meta);
  }, [
    meta.title,
    meta.description,
    meta.canonicalPath,
    meta.keywords,
    meta.ogImagePath,
    meta.ogType,
    meta.robots,
    meta.article?.publishedTime,
    meta.article?.modifiedTime,
    meta.article?.section,
    meta.article?.tags?.join(","),
  ]);
}
